<div class="page">
  <app-tab-superior *ngIf="this.isUserLogged" (toggleSidenavEmit)="toggleSidebar()"></app-tab-superior>

  <mat-sidenav-container class="sidenav-container" autosize>

    <mat-sidenav mode="side">
      <app-menu-lateral *ngIf="this.isUserLogged"></app-menu-lateral>
    </mat-sidenav>

    <mat-sidenav-content class="main-content">
      <app-toast aria-live="polite" aria-atomic="true"></app-toast>
      <router-outlet></router-outlet>
    </mat-sidenav-content>

  </mat-sidenav-container>
</div>

<ngx-spinner bdColor="var(--modal-bg)" size="large" color="var(--company-01)" type="ball-scale-multiple"
  [fullScreen]="true">
</ngx-spinner>